import { configureStore } from '@reduxjs/toolkit';
import { loadingBarReducer } from 'react-redux-loading-bar';
import homeReducer from '../features/home/homeSlice';
import userReducer from '../features/user/userSlice';
import walletReducer from '../features/wallet/walletSlice';
import voucherReducer from '../features/voucher/voucherSlice';
import subscriptionReducer from '../features/subscription/subscriptionSlice';
import snackbarReducer from '../features/snackbar/snackbarSlice';
import parkitNavReducer from '../components/ParkitNav/parkitNavSlice';
import deliveritNavReducer from '../components/DeliveritNav/deliveritNavSlice';

import deliverItDashboardReducer from '../features/deliverit/dashboard/dashboardSlice';
import parkitDashboardReducer from '../features/parkit/dashboard/dashboardSlice';
import deliveryRateReducer from '../features/deliverit/delivery_rate/deliveryRateSlice';
import orderGroupReducer from '../features/deliverit/order_group/orderGroupSlice';
import orderReducer from '../features/deliverit/order/orderSlice';
import vendorReducer from '../features/deliverit/vendor/vendorSlice';

import appointmentReducer from '../features/parkit/appointment/appointmentSlice';
import parkingAreaReducer from '../features/parkit/parkingArea/parkingAreaSlice';
import seasonPassProductsReducer from '../features/parkit/seasonPassProducts/seasonPassProductsSlice';
import buildingEnquiriesReducer from '../features/parkit/buildingEnquiries/buildingEnquiriesSlice';
import lprEnquiryReducer from '../features/parkit/lprEnquiry/lprEnquirySlice';
import engagementReducer from '../features/parkit/engagement/engagementSlice';
import ownerListingsReducer from '../features/parkit/ownerListings/ownerListingsSlice';
import listingReducer from '../features/parkit/listing/listingSlice';
import masterlistReducer from '../features/parkit/masterlist/masterlistSlice';
import rentingReducer from '../features/parkit/renting/rentingSlice';
import trackingSheetReducer from '../features/parkit/trackingSheet/trackingSheetSlice';
import terminationReducer from '../features/parkit/termination/terminationSlice';
import bulkEnquiriesReducer from '../features/parkit/bulkEnquiries/bulkEnquiriesSlice';
import archivedListingsReducer from '../features/parkit/archivedListings/archivedListingsSlice';
import archivedRentingsReducer from '../features/parkit/archivedRentings/archivedRentingsSlice';
import insuranceReducer from '../features/parkit/insurance/insuranceSlice';
import deliveryRateParkItReducer from '../features/parkit/deliveryRate/deliveryRateSlice';
import affiliateCampaignReducer from '../features/parkit/affiliateCampaign/affiliateCampaignSlice';
import affiliateCampaignReferralReducer from '../features/parkit/affiliateCampaignReferral/affiliateCampaignReferralSlice';
import referralCampaignReducer from '../features/parkit/referralCampaign/referralCampaignSlice';
import referralClaimReducer from '../features/parkit/referralClaim/referralClaimSlice';
import emailCampaignReducer from '../features/parkit/emailCampaign/emailCampaignSlice';
import customerReducer from '../features/parkit/customer/customerSlice';
import deleteRequestReducer from '../features/parkit/deleteRequest/deleteRequestSlice';
import payoutReportsReducer from '../features/parkit/payoutReports/payoutReportsSlice';
import payoutReducer from '../features/parkit/payout/payoutSlice';
import parkitSubscriptionReducer from '../features/parkit/subscription/subscriptionSlice';
import parkitFailedSubscriptionReducer from '../features/parkit/failedSubscription/failedSubscriptionSlice';
import subscriptionChargeHistoryReducer from '../features/parkit/subscriptionChargeHistory/subscriptionChargeHistorySlice';
import reviewsReducer from '../features/parkit/reviews/reviewsSlice';
import carInsuranceReducer from '../features/parkit/carInsurance/carInsuranceSlice';
import cpmsConnectionsReducer from '../features/parkit/cpmsConnections/cpmsConnectionsSlice';
import faqReducer from '../features/parkit/faq/faqSlice';
import permissionsReducer from '../features/permissions/permissionsSlice';
import staffReducer from '../features/staff/staffSlice';
import staffAuditReducer from '../features/staff/staffAuditSlice';
import roleEditorReducer from '../features/staff/roleEditorSlice';
import profileReducer from '../features/profile/profileSlice';
import notificationsReducer from '../features/notifications/notificationsSlice';
import favouritesReducer from '../features/favourites/favouritesSlice';

export const store = configureStore({
  reducer: {
    loadingBar: loadingBarReducer,
    home: homeReducer,
    user: userReducer,
    deliveryRate: deliveryRateReducer,
    deliverItDashboard: deliverItDashboardReducer,
    parkitDashboard: parkitDashboardReducer,
    orderGroup: orderGroupReducer,
    order: orderReducer,
    appointment: appointmentReducer,
    parkingArea: parkingAreaReducer,
    seasonPassProducts: seasonPassProductsReducer,
    buildingEnquiries: buildingEnquiriesReducer,
    lprEnquiry: lprEnquiryReducer,
    engagement: engagementReducer,
    ownerListings: ownerListingsReducer,
    listing: listingReducer,
    masterlist: masterlistReducer,
    renting: rentingReducer,
    trackingSheet: trackingSheetReducer,
    termination: terminationReducer,
    bulkEnquiries: bulkEnquiriesReducer,
    archivedListings: archivedListingsReducer,
    archivedRentings: archivedRentingsReducer,
    insurance: insuranceReducer,
    deliveryRateParkIt: deliveryRateParkItReducer,
    affiliateCampaign: affiliateCampaignReducer,
    affiliateCampaignReferral: affiliateCampaignReferralReducer,
    referralCampaign: referralCampaignReducer,
    referralClaim: referralClaimReducer,
    emailCampaign: emailCampaignReducer,
    customer: customerReducer,
    deleteRequest: deleteRequestReducer,
    payoutReports: payoutReportsReducer,
    payout: payoutReducer,
    parkitSubscription: parkitSubscriptionReducer,
    parkitFailedSubscription: parkitFailedSubscriptionReducer,
    subscriptionChargeHistory: subscriptionChargeHistoryReducer,
    wallet: walletReducer,
    voucher: voucherReducer,
    vendor: vendorReducer,
    snackbar: snackbarReducer,
    reviews: reviewsReducer,
    carInsurance: carInsuranceReducer,
    cpmsConnections: cpmsConnectionsReducer,
    faq: faqReducer,
    permissions: permissionsReducer,
    profile: profileReducer,
    notifications: notificationsReducer,
    favourites: favouritesReducer,
    staff: staffReducer,
    staffAudit: staffAuditReducer,
    roleEditor: roleEditorReducer,
    subscription: subscriptionReducer,
    parkitNav: parkitNavReducer,
    deliveritNav: deliveritNavReducer,
  },
});
